var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScalarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72964 35.7377C7.84128 34.0285 9.36222 32.6241 11.1544 31.6518C12.9465 30.6795 14.9531 30.1703 16.992 30.1703C19.0309 30.1703 21.0375 30.6795 22.8297 31.6518C24.6218 32.6241 26.1428 34.0285 27.2544 35.7377",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9911 27.2054C20.2692 27.2054 22.9266 23.9667 22.9266 19.9716C22.9266 15.9764 20.2692 12.7377 16.9911 12.7377C13.713 12.7377 11.0556 15.9764 11.0556 19.9716C11.0556 23.9667 13.713 27.2054 16.9911 27.2054Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5799 11.8799L31.9412 16.3865C31.903 16.4896 31.8341 16.5785 31.7438 16.6412C31.6536 16.704 31.5463 16.7377 31.4363 16.7377C31.3264 16.7377 31.2191 16.704 31.1288 16.6412C31.0385 16.5785 30.9696 16.4896 30.9314 16.3865L29.2954 11.8799L24.7888 10.2412C24.6857 10.203 24.5969 10.1341 24.5341 10.0438C24.4713 9.95358 24.4377 9.84627 24.4377 9.73632C24.4377 9.62638 24.4713 9.51907 24.5341 9.42881C24.5969 9.33855 24.6857 9.26966 24.7888 9.2314L29.2954 7.59545L30.9341 3.08884C30.9723 2.98576 31.0412 2.89687 31.1315 2.83409C31.2217 2.77132 31.3291 2.73767 31.439 2.73767C31.5489 2.73767 31.6563 2.77132 31.7465 2.83409C31.8368 2.89687 31.9057 2.98576 31.9439 3.08884L33.5826 7.59545L38.0892 9.23409C38.1923 9.27235 38.2811 9.34124 38.3439 9.4315C38.4067 9.52176 38.4403 9.62907 38.4403 9.73902C38.4403 9.84896 38.4067 9.95627 38.3439 10.0465C38.2811 10.1368 38.1923 10.2057 38.0892 10.2439L33.5799 11.8799Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalarIcon);
export default __webpack_public_path__ + "static/media/scalarIcon.146fcbafbd4dfca14107777ed9aff1f8.svg";
export { ForwardRef as ReactComponent };